import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon, PhoneIcon } from "lucide-react";
import { ChatWidget } from "./ChatWidget";
import { CONTACT } from "../../data/site";
import { trackCta } from "../../utils/analytics";
export function FloatingActions() {
  const [visible, setVisible] = useState(false);
  const {
    pathname
  } = useLocation();
  const hideRequest = pathname === "/contact";
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <>
      {/* Desktop: chat + floating request button */}
      <div className="fixed bottom-[calc(76px+env(safe-area-inset-bottom))] right-4 z-40 flex items-end gap-3 md:bottom-6 md:right-6" data-id="element-249" data-mp="3ir5vhadg7rf1">
        <AnimatePresence data-id="element-250" data-mp="3dt4c0oc41q31">
          {visible && !hideRequest && <motion.div initial={{
          opacity: 0,
          y: 10,
          scale: 0.96
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 10,
          scale: 0.96
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="hidden md:block" data-id="element-251" data-mp="1464kzslg5neg">
              <Link to="/contact" onClick={() => trackCta("floating_request", "/contact")} className="inline-flex min-h-[56px] items-center gap-2 rounded-full bg-accent px-6 font-medium text-white shadow-[0_10px_40px_rgba(10,87,255,0.35)] transition-colors duration-150 ease-out hover:bg-accent-bright" data-id="element-252" data-mp="z3vtl0o82teg">
                Request a Website <ArrowRightIcon className="h-4 w-4" data-id="element-253" data-mp="gfqq7ubh9ag6" />
              </Link>
            </motion.div>}
        </AnimatePresence>
        <ChatWidget data-id="element-254" data-mp="6h1kt10rpigt" />
      </div>

      {/* Mobile: sticky call / request bar */}
      <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-line bg-ink/90 p-2.5 pb-[calc(0.625rem+env(safe-area-inset-bottom))] backdrop-blur-xl md:hidden" data-id="element-255" data-mp="6j5l78zgjzcc">
        <a href={CONTACT.phones[0].href} onClick={() => trackCta("mobile_bar_call", "tel")} className="flex min-h-[48px] items-center justify-center gap-2 rounded-full border border-line-strong font-medium" data-id="element-256" data-mp="24boxb3517z3h">
          <PhoneIcon className="h-4 w-4" data-id="element-257" data-mp="2s342r4s3uwiy" /> Call
        </a>
        <Link to="/contact" onClick={() => trackCta("mobile_bar_request", "/contact")} className="flex min-h-[48px] items-center justify-center rounded-full bg-accent font-medium text-white" data-id="element-258" data-mp="2s0huf2xe4czo">
          Request Website
        </Link>
      </div>
    </>;
}